import HeaderLinkStyle from '@/styles/components/careers/navigation-section/_index.module.scss';
import { Formik, FormikControl, Form, InputError, InputStyle, LINK_TYPES, useState } from '@/imports-files/pages/career/customize-career-page';
import { useTranslation } from 'react-i18next';
export function HeaderLinks({formik, sidebar_section, customizeCareerAction}){
  const [headerDisabled, setHeaderDisabled] = useState(false);
  const {t} = useTranslation()
  return(
    <div className = {`${HeaderLinkStyle.HeaderLinks}`}>
      <label className = {`${HeaderLinkStyle.HeaderLinks__Title}`}>{t('career:nav_links:header')}</label>
        {formik.values.career_navigation_links_attributes.map((navigation, link_index) => {
          return ((navigation.navigation_type == LINK_TYPES.header) && <div className = {`${HeaderLinkStyle.HeaderLinks__Fields}`}  key={`header_links_${link_index}`}>
              <div className = {`${HeaderLinkStyle.HeaderLinks__Fields__LeftContent}`} key={`header_link_${link_index}`}>
                <div className = {`${HeaderLinkStyle.HeaderLinks__Fields__Label}`}>
                  <label>{t('career:nav_links:link_name')}</label>
                </div>
                <div className={`${HeaderLinkStyle.HeaderLinks__Fields__Input}`}>
                  <FormikControl
                    control       =   "input"
                    type          =   "text"
                    placeholder   =   {t('career:nav_links:link_name')}
                    name          =   {`career_navigation_links_attributes.${link_index}.name`}
                    className     =   {HeaderLinkStyle.HeaderLinks__Input}
                    formik        =   {formik}
                    onBlur       =    {() => {
                      customizeCareerAction.updateNavigationLink(formik, link_index)
                    }}
                  />
                </div>
              </div>
              <div className = {`${HeaderLinkStyle.HeaderLinks__Fields__RightContent}`}>
                <div className = {`${HeaderLinkStyle.HeaderLinks__Fields__Label}`}>
                  <label>{t('career:nav_links:link_url')}</label>
                </div>
                <div className={`${HeaderLinkStyle.HeaderLinks__Fields__Input}`}>
                  <FormikControl
                    control       =   "input"
                    type          =   "text"
                    placeholder   =   {t('career:nav_links:enter_url')}
                    name          =   {`career_navigation_links_attributes.${link_index}.url`}
                    className     =   {HeaderLinkStyle.HeaderLinks__Input}
                    formik        =   {formik}
                    onBlur       =    {() => {
                      customizeCareerAction.updateNavigationLink(formik, link_index)
                    }}
                  />
                </div>
              </div>
              <div className = {`${HeaderLinkStyle.HeaderLinks__Fields__Remove_Fields}`}>
                {(formik.values.career_navigation_links_attributes.filter((x) => x.navigation_type == LINK_TYPES.header).length > 1) && <span onClick={()=> {
                  customizeCareerAction.removeHFLinks(formik, LINK_TYPES.header, link_index)
                }}><img src ='/icons/career_icons/closebtn.svg'></img></span>}
              </div>
            </div>
          )
        })}
      { customizeCareerAction.showAddButton(formik, LINK_TYPES.header) && <div className = {`${HeaderLinkStyle.HeaderLinks__Add_More_Link}`}
        onClick={async(event) => {
        if(!headerDisabled){
          setHeaderDisabled(true)
          await customizeCareerAction.addHFLinks(formik, LINK_TYPES.header)
          setHeaderDisabled(false)
        }
        }}
      >
        <span className = {`${HeaderLinkStyle.HeaderLinks__Add_More_Link__Icon}`}><img src = "/icons/career_icons/plus.svg" ></img></span>
        <span className = {`${HeaderLinkStyle.HeaderLinks__Add_More_Link__Text}`}>{t('career:nav_links:add_more_links')}</span>
      </div>}
    </div>
  )
}